import { _ as t } from "../internals/export.js";
import { m as r } from "../internals/math-trunc.js";
t({
  target: "Math",
  stat: !0
}, {
  trunc: r
});